// admin/src/Component/FacebookConversion/List.js
import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    Filter,
    TextInput,
    Pagination
} from 'react-admin';

import DownloadFBTag from "./DownloadFBTag";

const FacebookConversionFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search name" source="name" alwaysOn options={{
            autoComplete: 'off',
            inputProps: { 'data-lpignore': 'true' },
        }} />
        <TextInput label="Search url" source="url" options={{
            autoComplete: 'off',
            inputProps: { 'data-lpignore': 'true' },
        }} />
        <TextInput label="Search pixel ID" source="pixel_id" options={{
            autoComplete: 'off',
            inputProps: { 'data-lpignore': 'true' },
        }} />
    </Filter>
);

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 500]} {...props} />;

export const FacebookConversionList = (props) => (
    <List filters={<FacebookConversionFilter />} {...props} title="Facebook conversions" pagination={<PostPagination/>} perPage={100} sort={{ field: 'updateDate' , order: 'DESC' }}>
        <Datagrid>
            <TextField source="name" label="Name" />
            <TextField source="url" label="URL" />
            <TextField source="pixel_id" label="Pixel ID" />
            <DateField source="update_date" sortBy="updateDate" showTime locales="nl-NL" />
            <EditButton />
            <DownloadFBTag />
        </Datagrid>
    </List>
);